import { Location } from "history";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import "common/types";

type Link<ArgsT extends Array<any>> = (...args: ArgsT) => string | Location;

type ReturnedCallback<ArgsT extends Array<any>> = (...args: ArgsT) => void;

/**
 Makes a callback to route to a link, following the same API as the link.
 i.e.
 const linkToCourse = (courseId) => `/some/path/${courseId}`

 const navigateToCourse = useNavigationCallback(linkToCourse)

 navigateToCourse("someCourseId")
 */

export default function useNavigationCallback<ArgsT extends Array<any> = any[]>(
  link: Link<ArgsT>
): ReturnedCallback<ArgsT> {
  const history = useHistory();

  return useCallback(
    (...args: ArgsT) => {
      const path = link(...args);

      history.push(path as string);
    },
    [link, history]
  );
}
